export default {
  title: 'Nuevo precio',
  fields: {
    product: {
      label: 'Producto',
    },
    is_not_personal: {
      label: 'Visible para todos',
    },
    is_default: {
      label: 'Predeterminado',
    },
    visible_to: {
      label: 'Visible para',
    },
  },
  buttons: {
    select_all: 'Seleccionar todo',
    save: 'Guardar',
    cancel: 'Cancelar',
  },
  feedback: {
    missing_info: 'Información incompleta',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos',
    price_got_created: 'Precio creado',
    price_got_updated: 'Precio actualizado',
  },
};
